import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Thread } from '@appbolaget/aware-model';
import { ClientAvatarComponent } from '@components/client-avatar/client-avatar.component';
import { ExcludeMyselfPipe } from '@helpers/pipes/exclude-myself.pipe';
import { HasUnreadMessagesPipe } from '@pages/messages/pipes/has-unread-messages.pipe';
import { LastMessagePipe } from '@pages/messages/pipes/last-message.pipe';
import { ThreadTitlePipe } from '@pages/messages/pipes/thread-title.pipe';
import { DateFnsModule } from 'ngx-date-fns';
@Component({
    selector: 'app-messages-thread-list-item',
    templateUrl: 'thread-list-item.component.html',
    imports: [
        ClientAvatarComponent,
        ExcludeMyselfPipe,
        ThreadTitlePipe,
        HasUnreadMessagesPipe,
        LastMessagePipe,
        DateFnsModule,
        MatIconModule,
    ],
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
            }
        `,
    ],
})
export class MessagesThreadListItemComponent {
    readonly thread = input<Thread>(undefined);
    readonly selected = input<boolean>(undefined);
}
